"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexToRotation = indexToRotation;
exports.rotationToIndex = rotationToIndex;
function indexToRotation(n) {
  return [0, 90, 270, 180][n % 4];
}
function rotationToIndex(degree) {
  var rotationValues = [0, 90, 270, 180];
  var index = rotationValues.indexOf((360 + degree) % 360);
  return index !== -1 ? index : 0;
}